import axios from "axios";
import { DeviceInfo } from "src/components/Authentication/interfaces/DeviceInfo";
import { generateUUID } from "./utilityHelper";

/**
 * Method to get the device info
 * @returns The device info
 */
const fetchDeviceInfo = async (personId?: string): Promise<DeviceInfo> => {
  const ipAddress = await getIpAddress();

  const userAgent = navigator.userAgent;
  const platform = navigator.platform;
  const deviceId = localStorage.getItem("deviceId") || generateUUID();
  localStorage.setItem("deviceId", deviceId);

  const currentDeviceInfo = {
    personId,
    ipAddress,
    userAgent,
    platform,
    deviceId,
  };

  return currentDeviceInfo;
};

/**
 * Method to get the IP Address
 * @returns The users IP address
 */
const getIpAddress = async (): Promise<string> => {
  const res = await axios.get("https://ipinfo.io/json");
  return res.data.ip;
};

export { fetchDeviceInfo };
